module.exports = __webpack_public_path__ + "img/logoWhile.52259b42.png";